import { ParsedUrlQuery } from 'querystring';

export const getPreviewInput = (routerQuery: ParsedUrlQuery) => {
  return {
    viewAt: routerQuery.viewAt as string,
    customerGroups: (routerQuery.customerGroups as string)?.split(','),
    global: routerQuery.global === 'true',
  };
};
